import ScheduleEditor from './ScheduleEditor';
import PortalRichTextField from './PortalRichTextField';
import Attention from '../../ReusableComponents/Attention';
import React from 'react';
import moment from 'moment';
import PortalFieldHelp from './PortalFieldHelp';
import { selectionFieldDescriptions } from './registrationFieldDescriptions';

export default function SelectionForm({ selection, disabled = false }) {
  return (
    <>
      <input
        type="hidden"
        name="ontest_faculdade_id"
        value={selection?.ontest_faculdade_id || ''}
      />
      <label className="portal-check">
        <input type="checkbox" name="enabled" defaultChecked={selection?.enabled !== false} disabled={disabled} />
        <span>Habilitar inscrições deste seletivo no portal</span>
        <PortalFieldHelp label="Habilitar inscrições deste seletivo no portal">
          Atualiza a habilitação na OnTest e no portal. Para aparecer aos candidatos, a publicação
          também deve estar como Publicado. As inscrições continuam respeitando os prazos e a situação configurados.
        </PortalFieldHelp>
      </label>
      <div className="portal-admin-grid">
        <label className="form-label">
          <span className="portal-field-label">
            Nome para publicação
            <PortalFieldHelp label="Nome para publicação">
              {selectionFieldDescriptions.title}
            </PortalFieldHelp>
            <Attention />
          </span>
          <input
            className="form-control"
            name="title"
            required
            maxLength={255}
            defaultValue={selection?.title}
            disabled={disabled}
          />
        </label>
        <label className="form-label">
          <span className="portal-field-label">
            Publicação
            <PortalFieldHelp label="Publicação">{selectionFieldDescriptions.status}</PortalFieldHelp>
            <Attention />
          </span>
          <select
            className="form-control form-select"
            name="status"
            defaultValue={selection?.status || 'draft'}
            disabled={disabled}
            required
          >
            <option value="draft">Rascunho</option>
            <option value="published">Publicado</option>
            <option value="archived">Arquivado</option>
          </select>
        </label>
        <label className="form-label">
          <span className="portal-field-label">
            Início das inscrições
            <PortalFieldHelp label="Início das inscrições">
              {selectionFieldDescriptions.registration_starts_at}
            </PortalFieldHelp>
            <Attention />
          </span>
          <input
            className="form-control"
            type="datetime-local"
            name="registration_starts_at"
            required
            defaultValue={
              selection ? moment(selection.registration_starts_at).format('YYYY-MM-DDTHH:mm') : ''
            }
            disabled={disabled}
          />
        </label>
        <label className="form-label">
          <span className="portal-field-label">
            Fim das inscrições
            <PortalFieldHelp label="Fim das inscrições">
              {selectionFieldDescriptions.registration_ends_at}
            </PortalFieldHelp>
            <Attention />
          </span>
          <input
            className="form-control"
            type="datetime-local"
            name="registration_ends_at"
            required
            defaultValue={
              selection ? moment(selection.registration_ends_at).format('YYYY-MM-DDTHH:mm') : ''
            }
            disabled={disabled}
          />
        </label>
      </div>
      <label className="form-label">
        <span className="portal-field-label">
          Situação no portal
          <PortalFieldHelp label="Situação no portal">
            {selectionFieldDescriptions.public_status}
          </PortalFieldHelp>
          <small className="text-muted">(opcional)</small>
        </span>
        <select
          name="public_status"
          className="form-control form-select"
          defaultValue={selection?.public_status || ''}
        >
          <option value="">Automática pelo período de inscrição</option>
          {[
            ['open', 'Inscrições abertas'],
            ['upcoming', 'Em breve'],
            ['closed', 'Encerradas'],
            ['in_progress', 'Em andamento'],
            ['finished', 'Finalizados'],
            ['suspended', 'Suspensos'],
            ['cancelled', 'Cancelados'],
          ].map(([v, t]) => (
            <option key={v} value={v}>
              {t}
            </option>
          ))}
        </select>
      </label>
      <ScheduleEditor schedule={selection?.schedule || []} />
      <label className="form-label">
        <span className="portal-field-label">
          Descrição
          <PortalFieldHelp label="Descrição">
            {selectionFieldDescriptions.description}
          </PortalFieldHelp>
          <Attention />
        </span>
        <textarea
          className="form-control"
          rows={5}
          required
          maxLength={30000}
          name="description"
          defaultValue={selection?.description}
          disabled={disabled}
        />
      </label>
      <PortalRichTextField
        name="terms"
        label="Condições para inscrição"
        required
        value={selection?.terms || ''}
        disabled={disabled}
        help={selectionFieldDescriptions.terms}
        placeholder="Descreva as condições que o candidato deverá aceitar."
      />
      <div className="portal-admin-checks">
        <label className="portal-check">
          <input
            type="checkbox"
            name="requires_review"
            defaultChecked={selection?.requires_review}
            disabled={disabled}
          />{' '}
          Analisar inscrições antes de vincular à prova
          <PortalFieldHelp label="Analisar inscrições antes de vincular à prova">
            {selectionFieldDescriptions.requires_review}
          </PortalFieldHelp>
        </label>
        <label className="portal-check">
          <input
            type="checkbox"
            name="allow_cancellation"
            defaultChecked={selection?.allow_cancellation}
            disabled={disabled}
          />{' '}
          Permitir cancelamento antes da vinculação
          <PortalFieldHelp label="Permitir cancelamento antes da vinculação">
            {selectionFieldDescriptions.allow_cancellation}
          </PortalFieldHelp>
        </label>
      </div>
    </>
  );
}
